const es = {
  // Navigation
  nav_home: "Inicio",
  nav_explore: "Explorar",
  nav_workspace: "Espacio de trabajo",
  ws_videos: "vídeos",
  ws_untitled: "Vídeo sin título",
  // A generation that failed. The card carries these until it is dismissed.
  ws_failed_title: "Vídeo fallido",
  ws_failed_refunded: "Tu crédito fue devuelto",
  ws_failed_dismiss: "Despedir",
  ws_failed_retry: "Intentar otra vez",
  ws_failed_retrying: "A partir de…",
  ws_failed_banner_one: "No se pudo generar un video",
  ws_failed_banner_many: "{n} vídeos fallaron",
  ws_failed_banner_body: "No se cobró nada: el crédito volvió a su cuenta. Inténtalo de nuevo o elige un tema diferente.",
  ws_empty_title: "Nada aquí todavía.",
  ws_empty_body: "Cada vídeo que hagas aparecerá aquí, el más nuevo primero.",
  ws_generate: "Generar",
  ws_composer_placeholder: "Describe una lección\u2026",
  ws_placeholder_hw: "Nombra la tarea... (opcional)",
  ws_placeholder_lecture: "Nombra la conferencia... (opcional)",
  ws_placeholder_self_study: "¿Qué quieres estudiar?",
  nav_search: "Buscar videos...",
  nav_search_yours: "Busca tus vídeos...",
  nav_notifications: "Notificaciones",
  nav_mark_all_read: "Marcar todo como le\u00eddo",
  nav_no_notifications: "No hay notificaciones a\u00fan",
  nav_no_notifications_sub: "Te notificaremos cuando tus videos est\u00e9n listos",
  nav_upgrade: "Mejorar plan",
  nav_billing: "Facturaci\u00f3n",
  nav_settings: "Configuraci\u00f3n",
  nav_contact: "Cont\u00e1ctanos",
  nav_api: "API",
  nav_sign_out: "Cerrar sesi\u00f3n",
  nav_just_now: "Ahora mismo",
  nav_minutes_ago: "hace {n}m",
  nav_hours_ago: "hace {n}h",
  nav_days_ago: "hace {n}d",
  nav_used_this_month: "{used} de {cap} usados este mes",
  // locale file, and this one is the obvious thing to reach for if a weekly bucket returns.
  nav_used_today: "{used} de {limit} usado esta semana",
  nav_free_daily: "4 vídeos gratis por semana",
  // Settings
  settings_title: "Configuraci\u00f3n",
  settings_profile: "Perfil",
  settings_change_avatar: "Cambiar avatar",
  settings_cancel: "Cancelar",
  settings_choose_wizard: "Elige tu mago",
  settings_display_name: "Nombre para mostrar",
  settings_your_name: "Tu nombre",
  settings_save: "Guardar",
  settings_saving: "Guardando...",
  settings_saved: "Guardado",
  settings_save_failed: "Error al guardar",
  settings_email: "Correo electr\u00f3nico",
  settings_notifications: "Notificaciones",
  settings_email_notif: "Notificaciones por correo",
  settings_email_notif_desc: "Recibe actualizaciones y anuncios por correo electr\u00f3nico",
  settings_language: "Idioma",
  settings_language_desc: "Elige el idioma de la app y la narraci\u00f3n de los videos",
  settings_data_title: "Tus datos",
  settings_data_desc: "Descargue una copia de los datos personales asociados con su cuenta, incluidos su perfil, videos, cursos, sesiones y mensajes de soporte. No se incluyen los registros internos del sistema ni los datos de procesamiento derivados.",
  settings_data_download: "descargar mis datos",
  settings_data_exporting: "Preparante…",
  settings_danger: "Zona de peligro",
  settings_delete_account: "Eliminar cuenta",
  settings_delete_desc: "Elimina permanentemente tu cuenta y todos los datos asociados. Esta acci\u00f3n no se puede deshacer.",
  settings_delete_confirm: "Esto eliminar\u00e1 permanentemente tu cuenta y todos tus datos. Escribe {keyword} para confirmar.",
  settings_delete_placeholder: "Escribe \"DELETE\" para confirmar",
  settings_permanently_delete: "Eliminar permanentemente",
  settings_deleting: "Eliminando...",
  explore_watch_now: "Ver ahora",
  // One pair of strings per scene; the eyebrow and the button are shared.
  explore_no_preview: "Sin vista previa",
  explore_no_videos: "A\u00fan no hay videos disponibles. \u00a1Vuelve pronto!",
  explore_featured_courses: "Cursos destacados",
  course_lesson_count: "{n, plural, one {# lesson} other {# lessons}}",
  course_back_to_explore: "Volver a Explorar",
  course_not_found: "Este curso no está disponible.",
  // Home Page
  home_hero: "Aprende cualquier cosa, ",
  home_hero_accent: "visualmente",
  home_placeholder: "\u00bfQu\u00e9 quieres aprender o resolver?",
  home_extracting: "Extrayendo preguntas...",
  home_videos_generated: "Se generar\u00e1n {n, plural, one {# v\u00eddeo} other {# v\u00eddeos}}",
  home_credits: "{n, plural, one {# cr\u00e9dito} other {# cr\u00e9ditos}}",
  home_remaining: "restantes este mes",
  home_enter_prompt: "Por favor, ingresa lo que quieres aprender o resolver",
  home_popular: "Lecciones populares",
  home_from_community: "De la comunidad",
  home_community_sub: "Mira lo que los estudiantes est\u00e1n creando",
  home_tips_label: "Del mago mago",
  home_tips_title: "Consejos y trucos",
  home_tip1_title: "Sea específico",
  home_tip1_desc: "No escribas un tema completo. Elija una idea, un concepto, una pregunta.",
  home_tip1_example: "Cómo funciona la replicación del ADN en células eucariotas",
  home_tip2_title: "Di para quién es",
  home_tip2_desc: "Una explicación en la escuela secundaria parece completamente diferente a una conferencia universitaria.",
  home_tip2_example: "Explicar las derivadas a alguien que acaba de aprender álgebra.",
  home_tip3_title: "Dile a Magi lo que quieres",
  home_tip3_desc: "Ejemplos, aplicaciones del mundo real paso a paso: solo dígalo y Magi lo seguirá.",
  home_tip3_example: "El ciclo del agua con ejemplos del mundo real y un resumen",
  home_tip_try: "Prueba algo como",
  home_proven_social: "Síguenos en Instagram",
  home_ig_desc_1: "M\u00e1s de ",
  home_ig_followers: "55,000 seguidores",
  home_ig_desc_2: "mira nuestros videos de matemáticas y ciencias en Instagram todos los días. Estos carretes están hechos con el mismo motor que usas aquí.",
  home_view_profile: "Ver perfil",
  home_subscribe_now: "Suscr\u00edbete ahora",
  home_sub_monthly: "Mensual",
  home_sub_yearly: "Anual",
  // goes false the moment either price moves, on the surface where that matters most.
  home_sub_yearly_save: "Ahorre {pct}%",
  home_sub_per_month: "/ mes",
  home_sub_billed_monthly: "facturado ${amount} cada mes",
  home_sub_processing: "Procesando...",
  home_sub_no_commitment: "Sin compromiso. Cancela cuando quieras.",
  home_sub_secured: "Protegido por Stripe",
  home_sub_headline: "Desbloquea más con {plan}",
  home_sub_due_now: "Vencimiento ahora",
  home_sub_trial_label: "{days}-día acceso completo",
  // choosing the plan directly is owed exactly what a trialist is owed.
  home_sub_monthly_terms: "Se te cobrará ${amount} hoy por {n} videos este mes. El {date} se renueva a ${amount}/mes a menos que canceles primero; cancela en cualquier momento desde Facturación.",
  // frequency, states that it happens automatically, and says where to cancel.
  home_sub_trial_terms: "Se te cobrará ${trial} hoy por {days} días de acceso completo, con un límite de {n} videos. La prueba no continúa en ${trial}; el {date} se convierte automáticamente en {planName} en ${plan} por mes (videos {full}) y ${plan} se cobra todos los meses a partir de entonces hasta que canceles. Cancela en cualquier momento desde Facturación.",
  home_sub_card: "Tarjeta de crédito o débito",
  home_sub_billed_once_yearly: "facturado ${amount} una vez al año",
  home_sub_billed_trial: "se factura ${amount} por {days} días y luego se renueva a ${renews} cada mes",
  home_sub_switch_plan: "¿Busca {plan} en su lugar?",
  home_sub_replaces_plan: "Reemplaza tu plan {plan}. Su fecha de facturación sigue siendo la misma: subir cobra la diferencia ahora, bajar comienza en su próxima renovación.",
  home_sub_change_now: "Ya estás en {plan}: se te cobró {amount} por la diferencia.",
  home_sub_change_later: "Pasarás a {plan} el {date}. Hoy no se cobra nada.",
  // the allowance changed; this one cannot.
  home_sub_feature_videos_n: "{n} videos por mes",
  // Pricing Page
  pricing_title: "Mejora tu plan",
  pricing_monthly: "Mensual",
  pricing_yearly: "Anual",
  pricing_save: "Ahorra 17%",
  pricing_best_value: "Mejor valor",
  pricing_your_plan: "Tu plan actual",
  pricing_get_started: "Comenzar",
  pricing_processing: "Procesando...",
  pricing_per_month: "/mes",
  pricing_billed_yearly: "Facturado ${amount}/a\u00f1o",
  pricing_videos_month: "{n, plural, one {# v\u00eddeo} other {# v\u00eddeos}}/mes",
  pricing_manage_cancel: "Gestionar o cancelar",
  pricing_manage_unavailable: "No encontramos una suscripción que gestionar. Contáctanos y lo solucionamos.",
  pricing_opening: "Abriendo...",
  billing_autorenew_monthly: "Se renueva automáticamente a ${amount}/mes hasta que canceles.",
  billing_autorenew_yearly: "Se renueva automáticamente a ${amount}/año hasta que canceles.",
  billing_autorenews_on: "Se renueva automáticamente {date} · cancelar en cualquier momento",
  pricing_secured: "Protegido por Stripe",
  pricing_login_required: "Inicia sesi\u00f3n para suscribirte",
  pricing_auth_error: "Error de autenticaci\u00f3n. Por favor, cierra sesi\u00f3n y vuelve a iniciarla.",
  pricing_feature_pdf: "Extracci\u00f3n de PDF e im\u00e1genes",
  pricing_feature_quality: "Modelo de mayor calidad",
  pricing_feature_speed: "Generaci\u00f3n m\u00e1s r\u00e1pida",
  pricing_feature_study: "Sesiones de estudio",
  pricing_free_hint: "Actualmente en el plan gratuito",
  // Billing Page
  billing_title: "Facturaci\u00f3n",
  billing_current_plan: "Plan actual",
  billing_payment_failed_title: "Tu plan está en pausa",
  billing_payment_failed_body: "No pudimos cobrar {amount}, por lo que su plan está en pausa. Actualice su tarjeta para iniciarla nuevamente; también seguiremos intentándolo.",
  billing_payment_failed_cta: "Arreglar el pago",
  billing_change_plan: "Cambiar plan",
  billing_invoices: "Facturas",
  billing_loading: "Cargando facturas...",
  billing_no_invoices: "No hay facturas a\u00fan",
  billing_date: "Fecha",
  billing_amount: "Monto",
  billing_status: "Estado",
  billing_invoice: "Factura",
  billing_view: "Ver",
  // Contact Page
  contact_title: "Cont\u00e1ctanos",
  contact_placeholder: "\u00bfC\u00f3mo podemos ayudarte?",
  contact_sent_desc: "Te responderemos lo antes posible.",
  contact_signin: "Inicie sesión para ponerse en contacto con el soporte.",
  // Generation Queue
  queue_title: "Cola",
  queue_active: "{n} activos",
  queue_generating: "{n} generando",
  queue_ready: "Listo para ver",
  queue_in_queue: "Esperando en la cola...",
  queue_almost_ready: "Casi listo...",
  queue_seconds_left: "{n}s restantes",
  queue_minutes_left: "{m}m {s}s restantes",
  queue_watch_now: "Ver ahora",
  queue_waiting: "Esperando en cola...",
  queue_empty: "No hay videos en cola",
  queue_empty_sub: "Genera un video para verlo aqu\u00ed",
  queue_clear: "Limpiar todo",
  queue_total: "{n} total",
  queue_first_time: "Tu video se est\u00e1 generando",
  queue_first_time_sub: "Generalmente ~2 min. Escuchar\u00e1s un sonido cuando est\u00e9 listo.",
  // Session Expired
  session_expired: "Sesi\u00f3n expirada",
  session_expired_desc: "Tu sesi\u00f3n ha expirado por razones de seguridad. Por favor, inicia sesi\u00f3n de nuevo para continuar.",
  // Cookie Banner
  cookie_text: "Usamos cookies para analizar el tr\u00e1fico del sitio y mejorar tu experiencia. Solo se establecen cookies esenciales por defecto.",
  cookie_learn_more: "Saber m\u00e1s",
  cookie_accept: "Aceptar todas",
  cookie_reject: "Rechazar no esenciales",
  // Create Project Modal
  create_new_project: "Nuevo proyecto",
  create_extracting: "Extrayendo...",
  create_select_problems: "Seleccionar problemas",
  create_select_topics: "Seleccionar temas",
  create_new_video: "Nuevo video",
  create_new_hw: "Nuevo proyecto de tarea",
  create_new_lecture: "Nuevo proyecto de clase",
  create_new_self_study: "Nuevo proyecto",
  create_video: "Video",
  create_homework: "Tarea",
  create_lecture: "Clase",
  create_self_study: "Proyecto",
  create_video_sub: "Generar un video",
  create_hw_sub: "Subir tarea",
  create_lecture_sub: "Subir diapositivas",
  create_self_study_sub: "Elige tus temas",
  create_video_prompt: "\u00bfQu\u00e9 debe explicar el video?",
  create_project_title: "T\u00edtulo del proyecto",
  create_video_hint: "Esto se usar\u00e1 como t\u00edtulo y como indicaci\u00f3n para tu video.",
  create_drop_hw: "Arrastra tu tarea aqu\u00ed",
  create_drop_lecture: "Arrastra tus diapositivas aqu\u00ed",
  create_file_types: "PDF, PNG, JPG, HEIC",
  // Shown over the composer while a file is being dragged onto it.
  composer_drop_hint: "Soltar para iniciar un proyecto",
  create_reading_hw: "Leyendo tu tarea",
  create_reading_lecture: "Leyendo tu clase",
  create_finding_problems: "Buscando y extrayendo problemas...",
  create_finding_topics: "Extrayendo temas...",
  create_add_video: "A\u00f1adir otro video",
  create_add_more_files: "A\u00f1adir m\u00e1s archivos",
  create_starting: "Iniciando generaci\u00f3n...",
  create_generate_video: "Generar video \u00B7 1 cr\u00e9dito",
  create_generate_n: "Generar {n, plural, one {# v\u00eddeo} other {# v\u00eddeos}} \u00B7 {n, plural, one {# cr\u00e9dito} other {# cr\u00e9ditos}}",
  create_create_project: "Crear proyecto \u00B7 {n, plural, one {# cr\u00e9dito} other {# cr\u00e9ditos}}",
  create_no_problems: "No se encontraron problemas. Intenta con una foto m\u00e1s clara o una p\u00e1gina diferente.",
  create_no_topics: "No se encontraron temas. Intenta con una foto m\u00e1s clara o un archivo diferente.",
  create_error: "Algo sali\u00f3 mal. Por favor, int\u00e9ntalo de nuevo.",
  create_extract_daily_limit: "Esos son todos los documentos de hoy. Más mañana.",
  create_video_topic_placeholder: "Tema del video {n}, ej. \"Autovalores y autovectores\"",
  video_share: "Compartir",
  // and made the two indistinguishable.
  video_followup_placeholder: "Generar vídeo de seguimiento...",
  video_chip_simpler: "Explicar m\u00e1s simple",
  video_chip_harder: "Ejemplo m\u00e1s dif\u00edcil",
  video_chip_real_world: "Uso en el mundo real",
  // spends a credit generating a new one.
  video_ask_title: "Pregunta por este vídeo",
  video_ask_cta: "Charla sobre esto",
  video_ask_placeholder: "Haz una pregunta...",
  video_ask_thinking: "Pensamiento...",
  video_ask_close: "Cerca",
  video_ask_chip_explain: "explica esa parte",
  video_ask_chip_example: "dar un ejemplo",
  video_ask_chip_why: "¿Por qué funciona eso?",
  video_ask_limit_reached: "Has alcanzado el límite de preguntas de hoy. Se reinicia mañana.",
  video_up_next: "A continuaci\u00f3n",
  video_no_suggested: "No hay videos sugeridos a\u00fan",
  video_untitled: "Video sin t\u00edtulo",
  video_created_recently: "Creado recientemente",
  video_just_now: "Ahora mismo",
  video_minutes_ago: "hace {n, plural, one {# minuto} other {# minutos}}",
  video_hours_ago: "hace {n, plural, one {# hora} other {# horas}}",
  video_days_ago: "hace {n, plural, one {# d\u00eda} other {# d\u00edas}}",
  video_weeks_ago: "hace {n, plural, one {# semana} other {# semanas}}",
  video_months_ago: "hace {n, plural, one {# mes} other {# meses}}",
  video_years_ago: "hace {n, plural, one {# a\u00f1o} other {# a\u00f1os}}",
  video_unknown_date: "Fecha desconocida",
  video_download_error: "Algo sali\u00f3 mal. Por favor, int\u00e9ntalo de nuevo.",
  // Search Results
  search_no_results: "Sin resultados",
  search_no_results_for: "No se encontraron resultados para \"{query}\"",
  search_all_videos: "Buscar todos los videos",
  search_enter_term: "Ingresa un t\u00e9rmino de b\u00fasqueda para encontrar videos",
  search_retry: "Reintentar b\u00fasqueda",
  auth_continue_google: "Continuar con Google",
  // sentence, and the box ships unticked — a pre-ticked box is not consent.
  home_sub_waiver: "Iniciar mi acceso de inmediato. Entiendo que esto significa que renuncio a mi derecho de {days} días a retirar dinero y obtener un reembolso.",
  home_sub_waiver_required: "Por favor confirma esto para continuar.",
  home_sub_agree_prefix: "Al continuar, aceptas nuestra",
  // floor is 13 — if that clause changes, this string and DIGITAL_CONSENT_AGE move with it.
  auth_min_age: "Debes tener {age} o más para usar Magi.",
  auth_agree_prefix: "Al iniciar sesi\u00f3n, aceptas nuestros ",
  auth_terms: "T\u00e9rminos de servicio",
  auth_and: " y ",
  auth_privacy: "Pol\u00edtica de privacidad",
  auth_email_optin: "Envíame consejos y actualizaciones",
  // Auth modal (Google + email/password)
  auth_signin_title: "Iniciar sesión en Magi",
  auth_signin_desc: "Continúe donde lo dejó.",
  auth_signup_title: "Crea tu cuenta",
  auth_signup_desc: "Gratis para comenzar, no se necesita tarjeta.",
  auth_or: "o",
  auth_continue_email: "Continuar con el correo electrónico",
  auth_signing_in: "Iniciando sesión…",
  auth_working: "Sólo un segundo…",
  auth_email_placeholder: "Dirección de correo electrónico",
  auth_password_placeholder: "Contraseña",
  auth_signin_submit: "Iniciar sesión",
  auth_signup_submit: "Crear una cuenta",
  auth_no_account: "¿Nuevo aquí?",
  auth_signup_link: "Crea una cuenta",
  auth_have_account: "¿Ya tienes una cuenta?",
  auth_signin_link: "Iniciar sesión",
  auth_forgot_password: "¿Olvidaste tu contraseña?",
  auth_reset_title: "Restablece tu contraseña",
  auth_reset_desc: "Le enviaremos un enlace por correo electrónico para configurar uno nuevo.",
  auth_reset_submit: "Enviar enlace de reinicio",
  auth_reset_sent: "Revise su correo electrónico para ver el enlace de reinicio.",
  auth_back_to_signin: "Volver para iniciar sesión",
  // Full-screen wall shown to a signed-in account that has not confirmed its address.
  verify_wall_title: "Confirma tu correo electrónico para continuar",
  verify_wall_desc: "Enviamos un enlace de confirmación a {email}. Haz clic en él y luego regresa aquí.",
  verify_wall_check: "lo he confirmado",
  verify_wall_checking: "De cheques...",
  verify_wall_still_unverified: "Aún no confirmado. Haga clic en el enlace del correo electrónico y vuelva a intentarlo.",
  verify_wall_resend: "enviar el enlace nuevamente",
  verify_wall_resent: "Enviado. Revisa tu bandeja de entrada y tu carpeta de spam.",
  verify_wall_wrong_account: "¿Cuenta equivocada? desconectar",
  // The screen the confirmation LINK lands on, replacing Firebase's unbranded handler page.
  verify_action_working_title: "Confirmando tu correo electrónico",
  verify_action_working_desc: "Un momento.",
  verify_action_done_title: "Estás todo listo",
  verify_action_done_desc: "Su correo electrónico está confirmado. Bienvenido a Magi.",
  verify_action_done_cta: "Empezar a aprender",
  verify_action_failed_title: "Ese enlace no funcionó",
  verify_action_failed_desc: "Es posible que ya haya sido utilizado o que haya caducado. Regresa y envíate uno nuevo.",
  verify_action_failed_cta: "Volver a Magi",
  // Wall copy — each surface names what signing in actually gets you
  auth_watch_title: "Inicia sesión para mirar",
  auth_watch_desc: "Crea una cuenta gratuita para reproducir este vídeo.",
  auth_watch_ready_title: "Tu vídeo está listo",
  auth_watch_ready_desc: "Inicia sesión para verlo; se guardará en tu cuenta.",
  // rather than saying "sign in" twice — the specific ask converts, the generic one nags.
  auth_download_title: "Inicia sesión para descargar",
  auth_download_desc: "Crea una cuenta gratuita para guardar este vídeo.",
  auth_ask_title: "Inicia sesión para preguntar",
  auth_ask_desc: "Crea una cuenta gratuita para preguntar sobre este vídeo.",
  auth_browse_title: "Inicia sesión para navegar",
  auth_browse_desc: "Cree una cuenta gratuita para explorar cada lección.",
  auth_workspace_title: "Inicia sesión para ver tu trabajo",
  auth_workspace_desc: "Tus lecciones y proyectos viven en tu cuenta.",
  auth_generate_title: "Inicia sesión para seguir creando",
  auth_generate_desc: "Las cuentas gratuitas obtienen un vídeo todos los días.",
  video_restricted: "Este vídeo aún no está disponible.",
  // Share sheet
  share_title: "Comparte este vídeo",
  share_desc_mobile: "Publícalo en tu historia, envíaselo a un amigo o copia el enlace.",
  share_desc_desktop: "Copie el enlace o descargue el video para publicarlo desde su teléfono.",
  share_to_apps: "Compartir en Instagram y más",
  share_copy_link: "Copiar enlace",
  share_copied: "Enlace copiado",
  share_download: "Descargar vídeo",
  share_preparing: "Preparándolo…",
  share_watermark_note: "Los vídeos compartidos incluyen magiacademy.com.",
  // Welcome Modal (post-signup)
  welcome_title: "Bienvenidos a los magos",
  welcome_subtitle: "Tienes 4 vídeos gratis para empezar.",
  welcome_optin_reward: "+1 vídeo gratis",
  welcome_continue: "Continuar",
  age_gate_continue: "Continuar",
  age_gate_saving: "Ahorro...",
  // Landing Page
  landing_hero: "Escribe un tema.",
  landing_hero2: "Obtenga una lección en video.",
  landing_subtitle: "Magi convierte cualquier tema en un vídeo narrado bellamente animado en cuestión de minutos. No se necesita filmación, ni edición, ni experiencia.",
  landing_signup_google: "Regístrate con Google",
  landing_signing_in: "Iniciando sesi\u00f3n...",
  landing_chat_bubble: "¿Cómo utiliza el GPS la relatividad?",
  landing_stats_title: "Con la confianza de estudiantes de todo el mundo",
  landing_stat_videos: "3000+",
  landing_stat_videos_desc: "Vídeos generados",
  landing_stat_languages_desc: "Idiomas",
  landing_stat_speed: "~1 minuto",
  landing_stat_speed_desc: "tiempo de generacion",
  landing_feature_lecture_title: "Deja tus apuntes de clase, obtén vídeos",
  landing_feature_lecture_desc: "Sube tus diapositivas o notas. Magi saca cada tema y genera una explicación en video para cada uno.",
  landing_feature_hw_title: "¿Atrapado en la tarea? Súbelo.",
  landing_feature_hw_desc: "Coloque un conjunto de problemas y Magi extraerá cada problema y luego lo guiará a través de la solución en un video paso a paso.",
  landing_feature_chat_title: "Haz preguntas mientras miras",
  landing_feature_chat_desc: "Cada vídeo viene con un tutor de IA con el que puedes chatear. Haga preguntas de seguimiento, obtenga explicaciones más profundas o solicite un nuevo video sobre una parte específica que desee comprender mejor.",
  landing_feature_lang_title: "Aprende en tu idioma",
  landing_feature_lang_desc: "Magi genera videos en inglés, español, hindi, chino, japonés y más. Escriba su tema en cualquier idioma y obtenga una lección completamente narrada en ese idioma.",
  landing_cta_title: "Empieza a aprender en segundos",
  landing_cta_google: "Continuar con Google",
  // Onboarding Bubbles
  onboarding_step1: "Esto no es un chatbot \u2014 escribe un tema y te generar\u00e9 una lecci\u00f3n en video completa.",
  onboarding_step2: "O arrastra un PDF o foto \u2014 convertir\u00e9 cada problema en una soluci\u00f3n paso a paso en video",
  onboarding_step3: "\u00a1Dale a ir y tu video entra en la cola. Puedes seguir navegando mientras se renderiza!",
  onboarding_generating: "Esta es su lección que se aprende en un par de minutos. Sigue navegando si quieres; Aterrizará aquí cuando esté listo.",
  onboarding_skip: "Omitir",
  onboarding_next: "Siguiente",
  onboarding_done: "\u00a1Entendido!",
  // Generating Cards Row
  generating_label: "Generando",
  // Lecture Session (Self Study)
  lecture_loading: "Cargando...",
  lecture_fallback_title: "Clase",
  lecture_building: "Construyendo video...",
  lecture_building_time: "Esto generalmente toma 2-4 minutos",
  lecture_failed: "La generaci\u00f3n del video fall\u00f3",
  lecture_no_video: "A\u00fan no hay video",
  lecture_followup: "Seguimiento",
  lecture_now_playing: "Reproduciendo ahora",
  lecture_tab_videos: "Videos",
  lecture_tab_chat: "Chat",
  lecture_chat_empty: "Pregunta lo que sea sobre este tema",
  lecture_chat_chip1: "Explicar de forma simple",
  lecture_chat_chip2: "Dame un ejemplo",
  lecture_chat_chip3: "\u00bfPor qu\u00e9 es \u00fatil?",
  lecture_chat_placeholder: "Pregunta sobre este tema...",
  lecture_followup_placeholder: "A\u00f1adir un video de seguimiento...",
  lecture_chat_error: "Lo siento, no pude procesar eso. Int\u00e9ntalo de nuevo.",
  lecture_chat_generic_error: "Algo sali\u00f3 mal. Int\u00e9ntalo de nuevo.",
  // Home shortcuts — square cards that jump to the Workspace composer preset to a mode
  home_sc_hw_title: "Tarea PDF",
  home_sc_hw_desc: "Cargue un conjunto de problemas y obtenga un video resuelto para cada pregunta",
  home_sc_lecture_title: "PDF de la conferencia",
  home_sc_lecture_desc: "Convierta diapositivas o notas en una serie de lecciones",
  home_sc_course_title: "Crear un curso",
  home_sc_course_desc: "Planificar una secuencia de lecciones sobre un tema.",
  // Misc
  generic_error: "Algo sali\u00f3 mal. Por favor, int\u00e9ntalo de nuevo.",
  loading: "Cargando...",
};

export default es;
